import { gql } from "lib/apolloClient";
import { projectAttachmentFragment } from "UnitPlans/modules/UnitPlanFragments";

export const updateProjectDeadlineMutation = gql`
  mutation updateProjectTask($input: UpdateProjectTaskInput!) {
    project {
      updateProjectTask(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateProjectDeadlineSubmissionMutation = gql`
  mutation updateProjectSubmission($input: UpdateProjectSubmissionInput!) {
    project {
      updateProjectSubmission(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const deleteAttachmentMutation = gql`
  mutation deleteAttachments($attachmentIds: [ID]!) {
    platform {
      deleteAttachments(attachmentIds: $attachmentIds) {
        isSuccess
        warning
      }
    }
  }
`;
export const updateAttachmentMutation = gql`
  mutation updateAttachment($input: AttachmentUpdateInput!) {
    platform {
      updateAttachment(input: $input) {
        ...attachmentItemV2
      }
    }
  }
  ${projectAttachmentFragment.attachment}
`;

export const updateSubmissionItemResponseMutation = gql`
  mutation UpdateProjectTaskSubmissionItemResponseResponse(
    $input: UpdateProjectTaskSubmissionItemResponseInput!
  ) {
    project {
      updateSubmissionItemResponse(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
